import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';

import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../environments/environment';
import { ApiEndpoints } from '../enum/api-endpoint';
import { RestErrorHandler } from './rest-error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class GetRadiosService {
  httpHeaders: any;
  musicPlayerBackendUrl = environment.musicPlayerBackendUrl;
  basicAuthUser = environment.basicAuthUser;

  constructor(
    private httpClient: HttpClient,
    private errorHandler: RestErrorHandler
  ) {
    this.httpHeaders = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers':
          'Access-Control-Allow-Headers, Origin, X-Requested-With, Content-Type, Accept, Authorization',
        'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
        Authorization: 'Basic ' + btoa(this.basicAuthUser),
      }),
    };
  }

  getRadios(countryCode: string): Observable<ArrayBuffer> {
    let getAllRadios =
      this.musicPlayerBackendUrl +
      ApiEndpoints.ALL_RADIOS +
      '?countryCode=' +
      countryCode;
    return this.httpClient
      .get(getAllRadios, this.httpHeaders)
      .pipe(catchError(this.errorHandler.handleError));
  }
}
